import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Suppress errors from external scripts (Emergent platform, extensions, analytics)
window.addEventListener('error', (e) => {
  if (e.filename && !e.filename.includes(window.location.origin)) {
    e.stopImmediatePropagation();
  }
});
window.addEventListener('unhandledrejection', (e) => {
  if (e.reason && e.reason.message === 'Failed to fetch') {
    e.stopImmediatePropagation();
    e.preventDefault();
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
